// Quacktris — stack the blocks, clear the lines.
const SHAPES = {
  I: [[0, 1], [1, 1], [2, 1], [3, 1]], O: [[1, 0], [2, 0], [1, 1], [2, 1]],
  T: [[1, 0], [0, 1], [1, 1], [2, 1]], S: [[1, 0], [2, 0], [0, 1], [1, 1]],
  Z: [[0, 0], [1, 0], [1, 1], [2, 1]], J: [[0, 0], [0, 1], [1, 1], [2, 1]], L: [[2, 0], [0, 1], [1, 1], [2, 1]],
};
const COLORS = { I: "#22d3ee", O: "#fbbf24", T: "#c084fc", S: "#34d399", Z: "#f87171", J: "#60a5fa", L: "#fb923c" };
const TYPES = Object.keys(SHAPES);
const norm = (c) => { const mx = Math.min(...c.map((p) => p[0])), my = Math.min(...c.map((p) => p[1])); return c.map(([x, y]) => [x - mx, y - my]); };
const rot = (c) => norm(c.map(([x, y]) => [y, -x]));

export function createTetris(host) {
  const { ctx, input } = host;
  const COLS = 10, ROWS = 20, W = host.W, H = host.H, cell = W / COLS;
  const grid = Array.from({ length: ROWS }, () => Array(COLS).fill(null));
  let piece, drop = 0, speed;
  const newPiece = () => { const t = TYPES[(Math.random() * TYPES.length) | 0]; return { t, cells: SHAPES[t].map((p) => [...p]), x: 3, y: 0 }; };
  const collide = (p, cells = p.cells, ox = 0, oy = 0) => cells.some(([cx, cy]) => { const x = p.x + cx + ox, y = p.y + cy + oy; return x < 0 || x >= COLS || y >= ROWS || (y >= 0 && grid[y][x]); });
  piece = newPiece(); speed = 0.6;
  const lock = () => {
    piece.cells.forEach(([cx, cy]) => { const x = piece.x + cx, y = piece.y + cy; if (y >= 0) grid[y][x] = COLORS[piece.t]; });
    let cleared = 0;
    for (let r = ROWS - 1; r >= 0; r--) { if (grid[r].every((c) => c)) { grid.splice(r, 1); grid.unshift(Array(COLS).fill(null)); cleared++; r++; } }
    if (cleared) { this_score(cleared); host.sfx.win?.(); }
    piece = newPiece(); speed = Math.max(0.12, 0.6 - Math.floor(gScore.v / 500) * 0.05);
    if (collide(piece)) gOver.v = true;
  };
  const gScore = { v: 0 }, gOver = { v: false };
  const this_score = (n) => { gScore.v += [0, 100, 300, 500, 800][n] || 800; };
  return {
    dim: "2d", w: W, h: H, controls: ["left", "right", "down", "a"], get score() { return gScore.v; }, get over() { return gOver.v; },
    frame(dt) {
      for (const a of input.taps) {
        if (a === "left" && !collide(piece, piece.cells, -1, 0)) piece.x--;
        if (a === "right" && !collide(piece, piece.cells, 1, 0)) piece.x++;
        if (a === "down") { if (!collide(piece, piece.cells, 0, 1)) piece.y++; }
        if (a === "a" && piece.t !== "O") { const rc = rot(piece.cells); const save = piece.cells; piece.cells = rc; if (collide(piece)) { if (!collide(piece, rc, -1, 0)) piece.x--; else if (!collide(piece, rc, 1, 0)) piece.x++; else piece.cells = save; } }
      }
      drop += dt; const sp = input.held.down ? 0.05 : speed;
      if (drop >= sp) { drop = 0; if (!collide(piece, piece.cells, 0, 1)) piece.y++; else lock.call(this); }
      ctx.fillStyle = "#070a1c"; ctx.fillRect(0, 0, W, H);
      for (let r = 0; r < ROWS; r++) for (let c = 0; c < COLS; c++) if (grid[r][c]) { ctx.fillStyle = grid[r][c]; ctx.fillRect(c * cell + 1, r * cell + 1, cell - 2, cell - 2); }
      ctx.fillStyle = COLORS[piece.t]; piece.cells.forEach(([cx, cy]) => { const x = piece.x + cx, y = piece.y + cy; if (y >= 0) ctx.fillRect(x * cell + 1, y * cell + 1, cell - 2, cell - 2); });
    },
  };
}
